import { Flex } from 'antd';

const PackageFilters = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      align="center"
      justify="flex-start"
      gap={20}
      wrap="wrap"
      className="package-filters-container"
    >
      <Flex wrap={'wrap'} gap={20} align={'center'}>
        {children}
      </Flex>
    </Flex>
  );
};

export default PackageFilters;
